import { actionMenuStore } from 'modules/profile/stores';

import { openFormModal } from 'src/modules/changeDistance/actions';

import { close } from './display';

export const openChangeDistanceModal = () => {
  const distance = actionMenuStore.distance;
  const settings = distance?.changeDistanceSettings;

  if (!distance || !settings?.eligibleDistances.length) {
    return;
  }

  openFormModal({
    raceId: distance.race_id,
    racerId: distance.racer_id,
    distanceId: distance.id,
    distanceName: distance.name,
    price: settings.price,
    currency: settings.currency,
    eligibleDistances: settings.eligibleDistances,
  });

  close();
};
